console.info('SCHMYT');
console.info('Website made by moritzebeling');

/* smoothscroll */

import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

/* element binders */

const navigationElement = document.querySelector('#navigation');

/* css variables */

function calculateCssVariables(){

    document.body.style.setProperty('--full-height', `${window.innerHeight}px`);

    if( window.innerWidth < 700 ){
        document.body.style.setProperty('--header-width', `0px`);
    } else {
        document.body.style.setProperty('--header-width', `${Math.ceil(navigationElement.offsetWidth)}px`);
    }

}
calculateCssVariables();
setTimeout(() => {
    calculateCssVariables();
}, 500);
window.addEventListener('resize', calculateCssVariables);

/* svelte */

import Marquee from './Marquee.svelte';

const marqueeElement = document.querySelector('#marquee');

const marqueeApp = new Marquee({
	target: marqueeElement,
    hydrate: true,
    props: {
        text: marqueeElement.innerHTML
    }
});

import Tour from './Tour.svelte';

const tourApp = new Tour({
	target: document.querySelector('#tour'),
    hydrate: true,
    props: {
        title: window.tourData.title,
        events: Object.values( window.tourData.dates ),
    }
});

export default [
    marqueeApp,
    tourApp
];

